import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopDevPageDisplaySide300x250 = /*#__PURE__*/ React.memo(()=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopDevPageDisplaySide300x250'], {
        debug: process.env.NODE_ENV !== 'production',
        refreshLimit: 10,
        refreshTime: 90,
        renderVisibleOnly: true,
        refreshVisibleOnly: true,
        sizes: [
            [
                '300',
                '250'
            ]
        ],
        report: {
            enabled: true,
            wording: 'Report Ad',
            position: 'bottom-right'
        }
    });
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, ()=>true // never rerender
);
DesktopDevPageDisplaySide300x250.displayName = 'DesktopDevPageDisplaySide300x250';
export default DesktopDevPageDisplaySide300x250;
